import { motion } from "framer-motion";
import { commonOpacity } from "../../animateConstant";
import { getFixedStyle } from "../../hook/useDeviceType";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { useTranslation } from "react-i18next";
import Wrapper from "./components/Wrapper";
import { useDispatch, useSelector } from "react-redux";
import { Button, Divider, Placeholder, Popup } from "semantic-ui-react";
import { IoAddCircleOutline, IoAddCircleSharp } from "react-icons/io5";
import { useNavigate } from "react-router";
import BalanceCard from "./components/balanceCard";
import TransactionCard from "../Transaction/components/TransactionCard";
import DetailWrapper from "../../components/detailWrapper";
import TransferWalletCard from "./components/transferWalletCard";
import { useEffect, useMemo, useState } from "react";
import WalletCard from "./components/walletCard";
import { getTransferWallet } from "../../api/getApi";
import {
  storeMemberInfo,
  storeTransferWallet,
} from "../../redux/action/member/memberAction";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import { flattenWalletObject } from "../../utils/flattenObject";
import LoadingLine from "../../components/Loading/LoadingLine";
import LoadingCard from "../../components/Loading/LoadingCard";
import LoadingWalletCard from "../../components/Loading/LoadingWalletCard";
import OneClickTransfer from "../PointQuery/components/oneClickTransfer";
import { FaExclamationCircle } from "react-icons/fa";
import { CURRENCY_SYMBOL } from "../../constant";

const SimpleProfile = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);

  const [selectedTab, setSelectedTab] = useState("single");
  const [transferLoading, setTransferLoading] = useState(false);

  const memberData = useSelector((state) => state.isMemberInfo);
  const isTransferWallet = useSelector((state) => state.isTransferWallet);
  const globalTrigger = useSelector((state) => state.isGlobalTrigger);
  const isDarkMode = useSelector((state) => state.isTheme === "dark");
  const { allGamePlatform } = useSelector((state) => state.isHandleAllGame);
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.isLoaderStatus);
  useEffect(() => {
    setTransferLoading(true);
    getTransferWallet()
      .then((data) => {
        dispatch(
          storeTransferWallet(flattenWalletObject(data.transferGameWalletInfo))
        );
      })
      .catch((err) => {})
      .finally(() => {
        setTransferLoading(false);
      });
  }, [globalTrigger]);

  const singleWallet = useMemo(() => {
    return memberData.gameWalletInfo || {};
  }, [memberData.gameWalletInfo]);

  const transferWallet = useMemo(() => {
    return isTransferWallet || {};
  }, [isTransferWallet]);

  const combineWallet = useMemo(() => {
    return { ...singleWallet, ...transferWallet };
  }, [singleWallet, transferWallet]);

  const rateList = useMemo(() => {
    return Object.keys(transferWallet).map((key) => {
      const array = key?.split("-");
      const findPlatform = allGamePlatform?.find(
        (item) => item.platform === array[0]
      );
      return {
        name: key,
        rate: parseInt(findPlatform?.exchangeRate),
      };
    });
  }, [transferWallet, allGamePlatform]);

  return (
    <DetailWrapper>
      <CloseDetailPage title={i18n("title")} />
      <section className="p-common-padding-y flex flex-col gap-[20px] px-[10px] mb-[10px]">
        <BalanceCard disabledCustomPath hiddenTransferButton />
        <section className="flex flex-col gap-[10px]">
          <div className="flex items-center justify-between gap-[5px] text-transaction-text">
            <span
              className={`font-medium  text-light-text cursor-pointer flex items-center gap-[5px]`}
            >
              {i18n("walletList")}
              <Popup
                trigger={
                  <FaExclamationCircle className="text-gold-text text-lg" />
                }
                content={
                  <div className="flex flex-col">
                    <span className="text-sm">{i18n("rateHint")}</span>
                    <Divider className="!my-[5px]" />
                    <section className="flex gap-[5px]">
                      <section className="">
                        {rateList?.map((item) => {
                          return (
                            <>
                              <div className="text-right">{item.name}:</div>
                            </>
                          );
                        })}
                      </section>
                      <section className="">
                        {rateList?.map((item) => {
                          return (
                            <>
                              <div className="font-bold">
                                {1000 / item.rate}
                                {CURRENCY_SYMBOL}
                              </div>
                            </>
                          );
                        })}
                      </section>
                    </section>
                  </div>
                }
                className="z-[999999]"
                style={{ zIndex: 9999999 }}
                inverted={isDarkMode}
              />
            </span>
            <OneClickTransfer />
          </div>

          <section className="flex flex-col gap-[10px]">
            {transferLoading ? (
              <LoadingWalletCard mapIndex={6} commonLoading={transferLoading} />
            ) : (
              <WalletCard eleWallet={combineWallet} />
            )}
          </section>
        </section>
      </section>
      {/* <section className="px-[10px] ">
        <p className="text-light-text text-sm font-semibold mb-[15px]">
          {i18n("last24HoursTransaction")}
        </p>
        <section>
          <TransactionCard
            type={`Bonus`}
            time={`23.04.2023 22:07`}
            description={`Winnings write-off from bonus account`}
            transactionId={`1188234919`}
            settledAmount={2.53}
          />
          <TransactionCard
            type={`Casino`}
            time={`01.12.2023 12:07`}
            isBet={25.33}
            description={`Bet in Play'n Go`}
            transactionId={`312352341`}
            settledAmount={22.51}
          />
          <TransactionCard
            type={`Casino`}
            time={`21.05.2023 20:37`}
            isBet={23.33}
            description={`Bet in Play'n Go`}
            transactionId={`691923885`}
            settledAmount={-12.53}
          />
          <TransactionCard
            type={`Bonus`}
            time={`23.04.2023 22:07`}
            description={`Winnings write-off from bonus account`}
            transactionId={`1188234919`}
            settledAmount={2.53}
          />
        </section>
      </section> */}
    </DetailWrapper>
  );
};

export default SimpleProfile;
